export type FileType = "document" | "image" | "scorm" | "excel" | "audio";

export const ALLOWED_MIME_TYPES: Record<FileType, string[]> = {
  image: ["image/gif", "image/png", "image/jpeg", ""],
  scorm: [
    "application/octet-stream",
    "application/zip",
    "application/x-zip-compressed",
    "application/x-compressed"
  ],
  document: [
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "application/vnd.ms-excel",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "application/vnd.ms-powerpoint",
    "application/vnd.openxmlformats-officedocument.presentationml.presentation",
    "application/x-pdf",
    "application/pdf"
  ],

  excel: [
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "application/vnd.ms-excel"
  ],
  audio: [
    "audio/wave",
    "audio/wav",
    "audio/webm",
    "audio/ogg",
    "application/ogg",
    "audio/mpeg3",
    "audio/x-mpeg-3",
    "audio/mpeg",
    "audio/mp3"
  ]
};

export const ALL_FILE_TYPES = Object.keys(ALLOWED_MIME_TYPES) as FileType[];

export const getMimeTypesByFileType = (types: FileType[]): string[] => {
  return types.reduce(
    (reduction, type) => {
      // @ts-ignore
      const mimeTypes = ALLOWED_MIME_TYPES[type];

      return [...reduction, ...mimeTypes];
    },
    [] as string[]
  );
};

export type Restrictions = {
  fileType?: FileType[];
  fileSizeInMbs?: number;
};

export type ValidationError = "notAllowedFileType" | "notAllowedFileSize";

export const validateFile = (
  file: File,
  restrictions: Restrictions | undefined
): ValidationError | null => {
  const getFileSizeInMbs = (fileSize: number) => {
    return fileSize / 1000000;
  };

  const checkIfFileTypeIsValid = () => {
    const getAllowedMimeTypes = (): FileType[] => {
      return restrictions && restrictions.fileType
        ? restrictions.fileType
        : ALL_FILE_TYPES;
    };

    if (!file.type) {
      return true;
    }

    return getMimeTypesByFileType(getAllowedMimeTypes()).some(
      type => type === file.type
    );
  };

  const checkIfFileSizeIsValid = () => {
    if (restrictions && restrictions.fileSizeInMbs) {
      return getFileSizeInMbs(file.size) < restrictions.fileSizeInMbs;
    } else {
      return true;
    }
  };

  if (!checkIfFileTypeIsValid()) {
    return "notAllowedFileType";
  }
  if (!checkIfFileSizeIsValid()) {
    return "notAllowedFileSize";
  }

  return null;
};
